import PropTypes from 'prop-types';
import { Col, OverlayTrigger, Tooltip } from 'react-bootstrap';

import { useWorkReportModals } from '../../../context/WorkReportModalsContext';
import { assignmentTypeEnum } from '../../../utils/dataStatus';
import { AttachedFilesPermissions } from '../../MonthlyServiceRequest/RequestDetailTypes';

const LinePositionName = (props) => {
  const {
    description,
    name,
    columnNumber,
    idWorkLine,
    idWorkPart,
    monthly,
    filesPermissions,
    lineBlockedBySap
  } = props;
  const { activeMonthlySummaryModal } = useWorkReportModals();
  const lineBlockedBySapStyle = lineBlockedBySap ? 'text-danger' : '';

  return (
    <>
      <OverlayTrigger
        delay={{
          show: 250,
          hide: 400
        }}
        overlay={<Tooltip id="button-tooltip">{description}</Tooltip>}
        placement="top"
      >
        <Col
          className="postionLineLabel"
          onClick={() => {
            activeMonthlySummaryModal({
              dailyWorkReport: {
                idParteLinea: idWorkLine,
                idParteTrabajo: idWorkPart,
                tipoAsignacion: monthly ? assignmentTypeEnum.Mensualizada : null
              },
              monthly,
              filesPermissions
            });
          }}
          sm={columnNumber}
        >
          <span className={lineBlockedBySapStyle}>{name.toUpperCase()}</span>
        </Col>
      </OverlayTrigger>
    </>
  );
};

LinePositionName.propTypes = {
  description: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  columnNumber: PropTypes.number.isRequired,
  idWorkLine: PropTypes.number.isRequired,
  idWorkPart: PropTypes.number.isRequired,
  monthly: PropTypes.bool,
  filesPermissions: AttachedFilesPermissions,
  lineBlockedBySap: PropTypes.bool.isRequired
};

LinePositionName.defaultProps = {
  monthly: false,
  filesPermissions: {
    visualize: false,
    write: false
  }
};

export default LinePositionName;
